import React from "react"

/**
 * UnpaidBanner shows for admin users when an account is marked as unpaid.
 *
 * IF THIS COMPONENT IS UPDATED, UPDATE THE RAILS PARTIAL AT app/views/layouts/_unpaid.html.erb
 */
export function UnpaidBanner() {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a href="" className="alert alert--banner alert--admin">
      <span className="label">admin</span>
      This account has been marked as unpaid and can not bypass the billing
      screen.
    </a>
  )
}
